import React from 'react';

import styles from './styles.module.scss';

interface BreadcrumbsProps {
  children: React.ReactNode [],
}

const Breadcrumbs = ({ children }: BreadcrumbsProps) => (
  <ol className={styles.breadcrumbs}>
    {children.map((child, index) => (
      <React.Fragment key={index}>
        {index !== 0 && (
          <li>
            /
          </li>
        )}
        <li>
          {child}
        </li>
      </React.Fragment>
    ))}
  </ol>
);

export default Breadcrumbs;
